export default (state) => state.administrators.data || {}
